import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getCurrentToken, getCurrentUser } from "./utility";
import { ROLE } from "../constant/constant";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const setComponent = (props) => {
    const { location } = props;
    const page = location.pathname.split("/");
    const accessPage = page[1] !== "import" ? page[1] : `${page[1]}/${page[2]}`; 
    const user = getCurrentUser();
    const previledge = ROLE[user?.role]?.previledge;
    const currentToken = getCurrentToken();

    if (currentToken && Math.floor(Date.now() / 1000) < currentToken?.expiryIn) {
      if (previledge.includes(accessPage)) {
        return <Component {...props} />;
      } else {
        return (
          <Redirect
            to={{
              pathname: "/unauthorize",
              state: { from: props.location },
            }}
          />
        );
      }
    } else {
      localStorage.removeItem("ROSTER-TOKEN");
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location },
          }}
        />
      );
    }
  };

  return <Route {...rest} render={setComponent} />;
};
